import { useReducer } from "react";
import { ScrollContextProps } from '../interface';

/** 初始数据 */
const initVirtualTableContext: ScrollContextProps = {
  offsetStart: 0,
  renderLen: 0,
  start: 0,
};

type PartialScrollContextProps = Partial<ScrollContextProps>;
type VirtualTableContextType = 'reset' | 'change';

export interface IVirtualTableContextAction {
  type: VirtualTableContextType;
  payload: PartialScrollContextProps;
}

function VirtualTableContextAction(
  state: ScrollContextProps,
  action: IVirtualTableContextAction,
) {
  switch (action.type) {
    case 'change':
      return {
        ...state,
        ...action.payload,
      };
    case 'reset':
      return {
        ...state,
        state: 0,
      };
    default:
      return state;
  }
}

function useVirtualTableContext() {
  const [virtualTableContext, dispatch] = useReducer(VirtualTableContextAction, initVirtualTableContext);
  function dispatchVirtualTable(
    type: VirtualTableContextType,
    payload: PartialScrollContextProps,
  ) {
    switch (type) {
      default:
        dispatch({ type, payload, });
    }
  }
  return {
    ...virtualTableContext,
    dispatchVirtualTable,
  };
}

export default useVirtualTableContext;
